export const BlogData =[
    {
        id:1,
        title:'Improve Self  Regular',
        category:'Motivation',
        img:'https://images.unsplash.com/photo-1528716321680-815a8cdb8cbe?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=776&q=80',
        author:'Shakil Mahammud',
        authorImg:'https://lh3.googleusercontent.com/p/AF1QipOrthM1RI7XQA1hw1MfaMEDSMabKAX7M8tM-DEw',
        date:'11 Jul, 2022',
        publishedTime:'6 min read'
    },
    {
        id:2,
        title:'Top 10 Microservices Design Patterns and Principles - Examples',
        category:'Developer',
        img:'https://images.unsplash.com/photo-1587620962725-abab7fe55159?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1631&q=80',
        author:'Shakil Mahammud',
        authorImg:'https://lh3.googleusercontent.com/p/AF1QipOrthM1RI7XQA1hw1MfaMEDSMabKAX7M8tM-DEw',
        date:'08 Aug, 2022',
        publishedTime:'12 min read'
    },
    {
        id:3,
        title:'Building a chat app with Socket.io and React 🚀',
        category:'React',
        img:'https://res.cloudinary.com/daily-now/image/upload/f_auto,q_auto/v1/posts/c2038635fe056578fb01a1f542cf9f01',
        author:'Learn with sumit',
        authorImg:'https://avatars.githubusercontent.com/u/73503432?v=4',
        date:'24 Aug, 2022',
        publishedTime:' 25min read'
    },
    {
        id:4,
        title:'Javascript Fundamentals',
        category:'Programing',
        img:'https://res.cloudinary.com/daily-now/image/upload/f_auto,q_auto/v1/posts/f7138569d3e705c32a5e7fb9ee9f06cb',
        author:'Developer',
        authorImg:'https://res.cloudinary.com/daily-now/image/upload/f_auto,q_auto/v1/posts/f7138569d3e705c32a5e7fb9ee9f06cb',
        date:'19 Jul, 2022',
        publishedTime:'29 min read'
    },
    {
        id:5,
        title:'The 2022 Python Programmer RoadMap',
        category:'Python',
        img:'https://res.cloudinary.com/daily-now/image/upload/f_auto,q_auto/v1/posts/8d553c05b64be4cfb475b5a68ef6cb6f',
        author:'Python Programmer',
        authorImg:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRovqvb5bDhAVKAKdkA5b_n6Z8f6IlGa2q_PA&usqp=CAU',
        date:'13 Jul, 2022',
        publishedTime:'10 min read'
    },
    {
        id:6,
        title:'Web Devlopment with python',
        category:'Python',
        img:'https://res.cloudinary.com/daily-now/image/upload/f_auto,q_auto/v1/posts/8d553c05b64be4cfb475b5a68ef6cb6f',
        author:'Python Programmer',
        authorImg:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRovqvb5bDhAVKAKdkA5b_n6Z8f6IlGa2q_PA&usqp=CAU',
        date:'13 Jul, 2022',
        publishedTime:'10 min read'
    },
]